export interface IPeopleCountMarker {
  name: string;
  available: boolean;
  address: string;
  coords: {
    latitude: number;
    longitude: number;
  };
  peopleCount: number;
  image: string;
}

export const PeopleCountMarkerList: IPeopleCountMarker[] = [
  {
    name: "벡스코",
    available: true,
    address: "부산 해운대구 APEC로 55",
    coords: {
      latitude: 35.1689766,
      longitude: 129.13604111,
    },
    peopleCount: 120,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20150902_124%2F14411748579799b4Jy_JPEG%2FSUBMIT_1441174809888_11639872.jpg",
  },
  {
    name: "이마트 트레이더스",
    available: true,
    address: "부산 연제구 좌수영로 241",
    coords: {
      latitude: 35.18492931271815,
      longitude: 129.11199889837593,
    },
    peopleCount: 427,
    image: "https://search.pstatic.net/common/?autoRotate=true&type=w560_sharpen&src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20210208_186%2F1612760142274HnOmz_JPEG%2FXuKxRHwuy9jhO5UZ4gBHTv_m.jpeg.jpg",
  },
  {
    name: "한꿈미술교습소",
    available: true,
    address: "부산광역시 해운대구 해운대로383번길 70",
    coords: {
      latitude: 35.1739929,
      longitude: 129.1402904,
    },
    peopleCount: 45,
    image: "https://search.pstatic.net/common/?autoRotate=true&type=w560_sharpen&src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20210329_6%2F1617016961924XbsuK_JPEG%2FF7s7w9JWf0NlJGl0yGrN8Iwa.jpg",
  },
  {
    name: "(재)부산디자인진흥원",
    available: true,
    address: "해운대구 센텀동로 57 부산디자인진흥원",
    coords: {
      latitude: 35.1740305,
      longitude: 129.1292549,
    },
    peopleCount: 20,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20210217_52%2F1613536661360R32RS_JPEG%2F2.jpg",
  },
  {
    name: "부산시립미술관",
    available: true,
    address: "부산 해운대구 APEC로 58",
    coords: {
      latitude: 35.1667411,
      longitude: 129.1370734,
    },
    peopleCount: 33,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20191226_282%2F1577344412460eY7wv_JPEG%2F6GwV6qanYbptk8614ml_DvKn.jpg",
  },
  {
    name: "부산문화콘텐츠콤플렉스",
    available: false,
    address: "수영강변대로 140",
    coords: {
      latitude: 35.1729475,
      longitude: 129.1254698,
    },
    peopleCount: 838,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20150901_87%2F1441089384513pkxX7_JPEG%2F21429071_0.jpeg",
  },
  {
    name: "부산광역시교육청창의융합교육원",
    available: true,
    address: "부산 연제구 토곡로 70",
    coords: {
      latitude: 35.1825502,
      longitude: 129.1003772,
    },
    peopleCount: 121,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20150902_124%2F14411748579799b4Jy_JPEG%2FSUBMIT_1441174809888_11639872.jpg",
  },
  {
    name: "홈플러스 익스프레스 부산연제점",
    available: true,
    address: "연제구 배산로 10",
    coords: {
      latitude: 35.1742027,
      longitude: 129.0931872,
    },
    peopleCount: 367,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20150902_124%2F14411748579799b4Jy_JPEG%2FSUBMIT_1441174809888_11639872.jpg",
  },
  {
    name: "판교도서관",
    available: true,
    address: "성남시 분당구 판교공원로 4길 27",
    coords: {
      latitude: 37.3920616,
      longitude: 127.0902689,
    },
    peopleCount: 211,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20150831_212%2F14410238255544WaTN_JPEG%2F116275613562523_0.jpg",
  },
  {
    name: "분당초등학교",
    available: true,
    address: "성남시 분당구 중앙공원로32번길 20",
    coords: {
      latitude: 37.3788201,
      longitude: 127.1295932,
    },
    peopleCount: 619,
    image: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20150831_226%2F1441003237690K2QAb_JPEG%2F107167588249133_0.jpg",
  },
]
